import './styles/fonts.css'

import ReactDOM from 'react-dom/client'
import TagManager from 'react-gtm-module'

import { Providers } from '@/components/templates/Providers.tsx'
import { isVelthuis } from '@/utils/common.ts'

import RouterRoot from './router/router.tsx'

const tagManagerArgs = {
  gtmId: isVelthuis
    ? import.meta.env.VELTHUIS_GTM_ID
    : import.meta.env.XPERT_GTM_ID,
}

TagManager.initialize(tagManagerArgs)

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
  <Providers>
    <RouterRoot />
  </Providers>,
  // </React.StrictMode>,
)
